import { render, staticRenderFns } from "./unternehmen.vue?vue&type=template&id=ac45a5c4&scoped=true&"
import script from "./unternehmen.vue?vue&type=script&lang=js&"
export * from "./unternehmen.vue?vue&type=script&lang=js&"
import style0 from "./unternehmen.vue?vue&type=style&index=0&id=ac45a5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45a5c4",
  null
  
)

export default component.exports